import {createTheme} from '@mui/material/styles';

const theme = createTheme({
  breakpoints: {
    values: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1350,
      xl: 1920,
    },
  },
  typography: {
    body1: {
      fontFamily: 'Roboto',
      fontSize: '1.125rem',
    },
    body2: {
      fontFamily: 'Roboto',
      fontSize: '1.125rem',
      fontWeight: 600,
    },
    body3: {
      fontFamily: 'Roboto',
      fontSize: '1.250rem',
      fontWeight: 600,
    },
    h2: {
      fontFamily: 'DM Sans',
      fontSize: '32px',
      fontWeight: 700,
    },
    h3: {
      fontFamily: 'DM Sans',
      fontWeight: 700,
      fontSize: '1.5rem',
    },
    h4: {
      fontFamily: 'Roboto',
      fontSize: '20px',
      fontWeight: 500,
    },
    h5: {
      fontFamily: 'DM Sans',
      fontWeight: 700,
    },
    subtitle1: {
      fontFamily: 'Roboto',
      fontWeight: 700,
      fontSize: '18px',
    },
    subtitle2: {
      fontFamily: 'Roboto',
      fontWeight: 700,
      fontSize: '1.25rem',
    },
    subtitle3: {
      fontFamily: 'Roboto',
      fontWeight: 500,
      fontSize: '18px',
    },
    subtitle3_1: {
      fontFamily: 'Roboto',
      fontWeight: 400,
      fontSize: '18px',
    },
    subtitle4: {
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontWeight: 400,
    },
    subtitle5: {
      fontFamily: 'Roboto',
      fontSize: '14px',
      fontWeight: 600,
    },
    subtitle6: {
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontWeight: 500,
    },
    subtitle7: {
      fontFamily: 'DM Sans',
      fontSize: '24px',
      fontWeight: 700,
    },
    subtitle8: {
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontWeight: 700,
    },
    subtitle9: {
      fontFamily: 'Roboto',
      fontSize: '14px',
      fontWeight: 400,
    },
    subtitle10: {
      fontFamily: 'Roboto',
      fontSize: '20px',
      fontWeight: 700,
    },
    subtitle11: {
      fontFamily: 'Roboto',
      fontSize: '17px',
      fontWeight: 700,
    },
    subtitle12: {
      fontFamily: 'Roboto',
      fontSize: '40px',
      fontWeight: 700,
    },
    subtitle13: {
      fontFamily: 'Roboto',
      fontSize: '30px',
      fontWeight: 700,
    },
    subtitle14: {
      fontFamily: 'Roboto',
      fontSize: '18px',
      fontWeight: 700,
    },
    subtitle15: {
      fontFamily: 'Roboto',
      fontSize: '12px',
      fontWeight: 700,
    },
    subtitle16: {
      fontFamily: 'Roboto',
      fontSize: '16px',
      fontWeight: 700,
    },
    subtitle17: {
      fontFamily: 'Roboto',
      fontSize: '14px',
      fontWeight: 400,
    },
    subtitle18: {
      fontFamily: 'Roboto',
      fontSize: '36px',
      fontWeight: 700,
    },
    subtitle19: {
      fontFamily: 'Roboto',
      fontWeight: 700,
      fontSize: '17px',
    },
    subtitle20: {
        fontFamily: 'Roboto',
        fontWeight: 500,
        fontSize: '20px',
    }
    },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          fontFamily: 'Roboto',
          fontWeight: 500,
          fontSize: '1.1rem',
          textTransform: 'initial',
          color: '#FFFFFF',
        },
      },
    },
  },
});

export default theme;
